import type { InputColorDesignTokens } from '@primeuix/themes/types/inputcolor';

export default {
    root: {
        borderColor: '{content.border.color}',
    },
    area: {
        borderRadius: '{content.border.radius}',
    },
    slider: {
        borderRadius: '{content.border.radius}',
        size: '1rem',
    },
    handle: {
        size: '1rem',
        borderColor: '#ffffff',
        borderWidth: '3px',
        shadow: '0px 0.5px 0px 0px rgba(0, 0, 0, 0.08), 0px 1px 1px 0px rgba(0, 0, 0, 0.14)',
        transitionDuration: '{transition.duration}',
        focusRing: {
            borderWidth: '2px',
            borderColor: '#ffffff',
            outlineWidth: '2px',
            outlineColor: 'rgba(255, 255, 255, 0.3)',
            outlineOffset: '2px',
        },
    },
    transparencyGrid: {
        color: '{surface.100}',
        background: '#ffffff',
        tileSize: '0.5rem',
    },
    swatch: {
        size: '2.25rem',
        borderRadius: '{content.border.radius}',
    },
} satisfies InputColorDesignTokens;
